
export default function ProblemOutcome() {
  const problems = [
    'Disconnected systems',
    'Manual, error-prone workflows',
    'Limited visibility into operations',
    'Compliance and accuracy risk',
    'Slow, reactive decision-making'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Problems */}
          <div>
            <h3 className="text-sm font-mono text-gray-500 uppercase tracking-wider mb-6">
              Common Operational Challenges
            </h3>
            <ul className="space-y-4">
              {problems.map((problem, index) => (
                <li key={index} className="flex items-start text-lg text-gray-700">
                  <span className="text-red-500 mr-3 mt-1">✕</span>
                  <span>{problem}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column - Solution */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Operational clarity isn't optional — it's foundational.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              As organizations grow, complexity compounds. Annalogix replaces fragmented processes with intelligent, AI-assisted workflows that reduce friction, improve accuracy, and create dependable operational pathways.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
